import { getAuthCode } from "./getAuthCode";
export const createCustomPostFromText = async (SetIsError, SetErrorMessage,text) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/createCustomPostFromText", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode(),text:text})
      });
     const result = await response.json();
      console.log("Status Code:", response.status);
      console.log("OK Status:", response.ok);
      if(response.ok){
      window.location.href = '/ideas';
      }
      else{
      SetIsError(true);
      SetErrorMessage(result.message);
      }
    } catch (error) {
      console.log(error);
    }
  };